/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { NewsCreateNewsResponse } from "./NewsCreateNewsResponse";

export type NewsCreateNewsResponseApiRespoonse = {
  data?: NewsCreateNewsResponse;
  status?: NewsCreateNewsResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace NewsCreateNewsResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
